export default __webpack_public_path__ + "static/media/wdg_logo_de.ea340fda.svg";